import { PROFILE_PAGE_TYPES } from '@common/types';
import { useProfileContext } from '@components/Contexts/ProfileContext';
import { ENABLE_AGENCY_PROFILE_CONTACT_FORM } from '@utils/constants';
import { useExperiments } from '@wix/fe-essentials-standalone';

const useProfileContactButton = () => {
  const { experiments } = useExperiments({ readOnly: true });
  const isAgencyContactFormEnabled = experiments.enabled(
    ENABLE_AGENCY_PROFILE_CONTACT_FORM,
  );

  const {
    partnerProfile,
    isMyProfile,
    enabled,
    isRenderedInModal,
    profilePageType,
  } = useProfileContext();

  // TODO: remove when usePublicPartnerProfiles spec is merged
  const shouldRenderContactButtonWithoutPageType =
    !isMyProfile && enabled && !isRenderedInModal;

  const havePageType = Boolean(profilePageType);

  const useMailToButton = profilePageType === PROFILE_PAGE_TYPES.agency;
  const email = partnerProfile?.professionalInformation?.email;

  return {
    isAgencyContactFormEnabled,
    isMyProfile,
    havePageType,
    shouldRenderContactButtonWithoutPageType,
    useMailToButton,
    email,
  };
};

export default useProfileContactButton;
